import React from "react";
import {Box, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {ReactComponent as PagesIcon} from "../../assets/promos&items/pages_icon_large.svg";
import {ReactComponent as PromotionsIcon} from "../../assets/promos&items/promotions_icon_large.svg";
import {ReactComponent as ItemsIcon} from "../../assets/promos&items/items_icon_large.svg";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {FlyerPageDto, FlyerPageSpotDto, PromoDto, PromoItemsDto} from "../../dtos";

const useStyles = makeStyles(() => ({
    reportColumn: {
        display: `flex`,
        flexDirection: `column`,
        alignItems: `center`,
        padding: `0 10px`,
        '& > MuiTypography-root': {
            fontSize: `12px`
        }
    }
}))


export const QualityCheckStatistic = () => {
    const flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const classes = useStyles();
    let totalPages = [], acceptedPages = [], totalFrames = [], acceptedFrames = [], totalPromotions = [],
        acceptedPromotions = [], totalItems = [], acceptedItems = [];
    flyerDetailsState.flyerPages.forEach((page: FlyerPageDto) => {
        totalPages.push(page);
        if (page.qualificationLevel === 2) {
            acceptedPages.push(page);
        }
        page.flyerPageSpots?.forEach((frame: FlyerPageSpotDto) => {
            totalFrames.push(frame);
            if (frame.qualificationLevel === 2) {
                acceptedFrames.push(frame)
            }
            frame.flyerPromos?.forEach((promo: PromoDto) => {
                totalPromotions.push(promo);
                if (promo.qualificationLevel === 2) {
                    acceptedPromotions.push(promo)
                }
                promo.flyerPromoItems?.forEach((item: PromoItemsDto) => {
                    totalItems.push(item);
                    if (item.qualificationLevel === 2) {
                        acceptedItems.push(item);
                    }
                })
            })
        })
    });
    return (
        <Box>
            <Box sx={{mb: `10px`}}>
                <Typography>
                    Total Approved (Green):
                </Typography>
            </Box>
            <Box sx={{display: `flex`}}>
                <Box className={classes.reportColumn}>
                    <Box>
                        <PagesIcon/>
                    </Box>
                    <Box mb={`10px`}>
                        <Typography>
                            Pages
                        </Typography>
                    </Box>
                    <Box mb={`10px`}>
                        <Typography>
                            {Math.round(acceptedPages.length / totalPages.length * 100)}%
                        </Typography>
                    </Box>
                    <Box>
                        <Typography>
                            {acceptedPages.length} / {totalPages.length}
                        </Typography>
                    </Box>
                </Box>
                <Box className={classes.reportColumn}>
                    <Box>
                        <PromotionsIcon/>
                    </Box>
                    <Box mb={`10px`}>
                        <Typography>
                            Frames
                        </Typography>
                    </Box>
                    <Box mb={`10px`}>
                        <Typography>
                            {
                                totalFrames.length
                                    ? `${Math.round(acceptedFrames.length / totalFrames.length * 100)}%`
                                    : `N/A`
                            }

                        </Typography>
                    </Box>
                    <Box>
                        <Typography>
                            {
                                totalFrames.length
                                    ? `${acceptedFrames.length} / ${totalFrames.length}`
                                    : `N/A`
                            }
                        </Typography>
                    </Box>
                </Box>

                <Box className={classes.reportColumn}>
                    <Box>
                        <ItemsIcon/>
                    </Box>
                    <Box mb={`10px`}>
                        <Typography>
                            Items
                        </Typography>
                    </Box>
                    <Box mb={`10px`}>
                        <Typography>
                            {
                                totalItems.length
                                    ? `${Math.round(acceptedItems.length / totalItems.length * 100)}%`
                                    : `N/A`
                            }


                        </Typography>
                    </Box>
                    <Box>
                        <Typography>
                            {
                                totalItems.length
                                    ? `${acceptedItems.length} / ${totalItems.length}`
                                    : `N/A`
                            }
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}